/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const Traveler = require('./traveler');

class TravelerList {
  constructor(rawTravelers) {
    this.list = _.map(rawTravelers, function (t) {
      const rawUser = t.user || {};
      const arg = _.merge(rawUser, t);
      if (!arg.id) {
        arg.id = t.user_id;
      }
      if (!arg.tel) {
        arg.tel = t.flight_tel;
      }
      return new Traveler(arg);
    });
  }

  static fromCount(count) {
    return new this(_.times(count, () => ({})));
  }

  static fromTravelerInformations(args) {
    const informations = args['informations']; // TravelerList
    const user = args['user']; // User
    const members = args['members']; // User
    const peoplenum = args['peoplenum'];

    // 出張人数分のtravelersを作成
    const travelers = this.fromCount(peoplenum);

    // travelersに、travelerInformationsをアサインする
    // self or memberの場合、travelrを作成してアサイン
    // companionの場合、そのままアサイン
    for (let i = 0; i < informations.list.length; i++) {
      var info = informations.list[i];
      if (travelers.list[i]) {
        if (info.user_id) {
          var traveler;
          if (parseInt(info.user_id) === parseInt(user.id)) {
            Object.assign(user, { info });
            traveler = new Traveler(user);
            traveler.type = 'self';
            travelers.setTravelerAtIndex(i, traveler);
          } else {
            var member = _.find(members, m => parseInt(m.id) === parseInt(info.user_id));
            if (member) {
              Object.assign(member, { info });
              traveler = new Traveler(member);
              traveler.type = 'member';
              travelers.setTravelerAtIndex(i, traveler);
            } else {
              Object.assign(info.user, { info });
              traveler = new Traveler(info.user);
              traveler.type = 'others';
              travelers.setTravelerAtIndex(i, traveler);
            }
          }
        } else {
          info.type = 'companion';
          info.travelerInformationId = info.id;
          info.id = ''; // user_idとして扱われるため
          info.birthday = info.flight_birthday;
          travelers.setTravelerAtIndex(i, info);
        }
      }
    }

    return travelers;
  }

  static fromQuery(args) {
    const queries = args['travelerQueries'];
    const user = args['user']; // User
    Object.assign(user, { search_query_id: queries[0].search_query_id });
    const members = args['members']; // User
    const peoplenum = args['peoplenum'];

    const travelers = this.fromCount(peoplenum);

    for (let i = 0; i < queries.length; i++) {
      var query = queries[i];
      if (travelers.list[i]) {
        var traveler;
        if (query.user_id) {
          if (parseInt(query.user_id) === parseInt(user.id)) {
            Object.assign(user, { info: query });
            traveler = new Traveler(user);
            traveler.type = 'self';
            travelers.setTravelerAtIndex(i, traveler);
          } else {
            var member = _.find(members, m => parseInt(m.id) === parseInt(query.user_id));
            if (member) {
              Object.assign(member, { search_query_id: queries[0].search_query_id, info: query });
              traveler = new Traveler(member);
              traveler.type = 'member';
              travelers.setTravelerAtIndex(i, traveler);
            }
          }
        } else {
          traveler = new Traveler(query);
          traveler.travelerInformationId = query.id;
          traveler.id = ''; // traveler_informationのidがuser_idとして扱われるため
          traveler.type = 'companion';
          travelers.setTravelerAtIndex(i, traveler);
        }
      }
    }

    return travelers;
  }

  static initialTravelers(args) {
    const user = args['user'];
    const peoplenum = args['peoplenum'];

    const travelers = this.fromCount(peoplenum);
    travelers.setTravelerAtIndex(0, new Traveler(user));
    if (peoplenum > 1) {
      _.forEach(_.range(1, peoplenum), function (i) {
        if (user.show_other_members) {
          return travelers.setTravelerTypeAtIndex(i, 'member');
        } else {
          return travelers.setTravelerTypeAtIndex(i, 'companion');
        }
      });
    }
    return travelers;
  }

  static fromTravelers(args) {
    let travelers = args['travelers'];
    const peoplenum = args['peoplenum'];
    const user = args['user'];
    if (travelers !== null) {
      travelers = travelers.map(function (traveler) {
        if (traveler.user_id !== null) {
          traveler.name = traveler.user.name;
          traveler.email = traveler.user.email;
          if (traveler.user_id === user.id) {
            traveler.type = 'self';
          } else {
            traveler.type = 'member';
          }
        } else {
          traveler.type = 'companion';
          traveler.name = traveler.last_name_roman + ' ' + traveler.first_name_roman;
        }
        return new Traveler(traveler);
      });
    }
    const travelerlist = this.fromCount(peoplenum);
    travelerlist.list = travelers;
    return travelerlist;
  }

  getFirstExistAccountTraveler() {
    return _.find(this.list, l => l.department.id);
  }

  getTravelersParam(reservingTrip) {
    if (reservingTrip == null) {
      reservingTrip = {};
    }
    return _.map(this.list, t => t.getTravelerParams(reservingTrip));
  }

  getQueryString() {
    let res = '';
    this.list.forEach((traveler, i) => (res += traveler.getQueryString(`travelers[${i}]`)));
    return res;
  }

  getTravelerNames() {
    return _.map(this.list, t => t.getTravelerName());
  }

  getTravelerShinkansenTypes(elementIndex = null) {
    if (_.filter(this.list, t => t.isTravelerShinkansenType(elementIndex)).length > 0) {
      return _.map(this.list, t => t.getTravelerShinkansenType(elementIndex));
    }

    return false;
  }

  setTravelerTypeAtIndex(i, type) {
    this.list[i] = new Traveler({ type });
    this.list[i].setInitialShinkansenTypes();
    return app.render();
  }

  setTravelerAtIndex(i, traveler) {
    this.list[i] = traveler;
    this.list[i].setInitialShinkansenTypes();
    return app.render();
  }

  addTraveler(raw) {
    if (raw == null) {
      raw = {};
    }
    this.list.push(new Traveler(raw));
    return app.render();
  }

  removeTravelerAtIndex(i) {
    this.list.splice(i, 1);
    return app.render();
  }

  removeLastTraveler() {
    this.list.pop();
    return app.render();
  }

  handleTravelerInfoChange(i, method) {
    return e => this.list[i][method](e.target.value);
  }

  handleTravelerBirthDayChange(i, method) {
    return birthday => this.list[i][method](birthday.format('YYYY-MM-DD'));
  }

  validationPromise() {
    const errors = {};
    this.list.forEach((t, i) => t.validate(errors, false));
    return _.omitBy(errors, _.isNil);
  }
}

module.exports = TravelerList;
